import api_client from '@/repositories';
import { ICustomQueryArgsRepository } from '@/types/utils/ICustomQueryArgs';
import { useQuery } from '@tanstack/react-query';

const QK_APP_CONFIG = 'application-config';

type IUseAppConfigArgs = ICustomQueryArgsRepository<typeof api_client.config.getConfig>;

export function useAppConfig(args?: IUseAppConfigArgs) {
	return useQuery({
		queryKey: [QK_APP_CONFIG],
		queryFn: api_client.config.getConfig,
		...args,
	});
}
